export default "__VITE_ASSET__a478fc80__"